import { AuthShell } from "../components";
import { useAuthUi } from "../context";

export function PrivacyPage() {
  const { t } = useAuthUi();
  return <AuthShell title={t("privacyTitle")} wide>
    <article className="legal"><p className="legal-meta">{t("legalDraft")}</p><p>{t("privacyBody1")}</p><p>{t("privacyBody2")}</p><p>{t("privacyBody3")}</p></article>
  </AuthShell>;
}

export function TermsPage() {
  const { t } = useAuthUi();
  return <AuthShell title={t("termsTitle")} wide>
    <article className="legal"><p className="legal-meta">{t("legalDraft")}</p><p>{t("termsBody1")}</p><p>{t("termsBody2")}</p><p>{t("termsBody3")}</p></article>
  </AuthShell>;
}
